export const getStepState = (stepNumber: number, currentStep: number) => {
  if (stepNumber < currentStep) {
    return 'completed';
  } else if (stepNumber === currentStep) {
    return 'current';
  } else {
    return 'pending';
  }
};
